<template>
  <div>
    <PageHeader :schema="$schemas.company" />
    <PageContent>
      <DynamicFormPage :schema="$schemas.company" :service="$api.companies" />
    </PageContent>
  </div>
</template>

<script>
import PageHeader from '@/components/PageHeader';
import PageContent from '@/components/PageContent';
import DynamicFormPage from '@/components/dynamics/DynamicFormPage';

export default {
  name: 'CreateCompany',
  components: { PageHeader, PageContent, DynamicFormPage },
  data() {
    return {};
  },
};
</script>
